import { render, staticRenderFns } from "./program.vue?vue&type=template&id=194c3e8f&scoped=true"
import script from "./program.vue?vue&type=script&lang=js"
export * from "./program.vue?vue&type=script&lang=js"
import style0 from "./program.vue?vue&type=style&index=0&id=194c3e8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194c3e8f",
  null
  
)

export default component.exports